import './scripts2';
import { Utils } from './module/utils';
import '../sass/style.scss';

// -----------------------------------------------
// スクロール無効
// -----------------------------------------------
function preventDefaultEvent(event) {
  event.preventDefault();
}

function disableScroll() {
  document.querySelector('body').style.overflow = 'hidden';
}

// -----------------------------------------------
// スクロール有効
// -----------------------------------------------
function enableScroll() {
  document.querySelector('body').style.overflow = '';
}

// -----------------------------------------------
// ハンバーガーを開閉する
// -----------------------------------------------
function toggleHamburger() {
  const hamburger = document.querySelector('.js-hamburger');
  const drawerMenu = document.querySelector('.js-drawer-menu');

  hamburger.classList.toggle('is-open');
  drawerMenu.classList.toggle('is-open');

  if (hamburger.classList.contains('is-open')) {
    disableScroll();
  } else {
    enableScroll();
  }
}

// -----------------------------------------------
// ハンバーガーメニュー内リンククリック時の処理
// -----------------------------------------------

// リンクにイベントリスナーを追加する関数
function addClickListenerToLinks(links) {
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault(); // デフォルトのアンカーリンクの動作を防止
      // メニューを閉じる
      toggleHamburger();
      // リンク先のURLを取得
      const href = this.getAttribute('href');
      // リンクのtarget属性をチェック
      const target = this.getAttribute('target');
      // 別窓で開くかどうか判定
      const openInNewWindow = target === '_blank';
      // ページ遷移
      if (openInNewWindow) {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    });
  });
}

// ドロワーメニュー内のリンクを取得
const drawerMenuLinks = document.querySelectorAll('.js-drawer-menu a');
// ヘッダー内のリンクを取得
const headerLinks = document.querySelectorAll('.js-header a');

// ドロワーメニューとヘッダーのリンクにイベントリスナーを追加
addClickListenerToLinks(drawerMenuLinks);
addClickListenerToLinks(headerLinks);

// -----------------------------------------------
// ハンバーガーを強制的に閉じる
// -----------------------------------------------
function forceCloseHamburger() {
  const hamburger = document.querySelector('.js-hamburger');
  const drawerNav = document.querySelector('.js-drawer-menu');

  if (!hamburger.classList.contains('is-open')) {
    // ハンバーガーが開いてなければ何もしない
    return;
  }

  hamburger.classList.remove('is-open');
  drawerNav.classList.remove('is-open');
  enableScroll();
}

// -----------------------------------------------
// 画面幅が変わったときにハンバーガーを閉じる
// -----------------------------------------------
window.addEventListener('resize', function() {
  // ここで画面幅の条件をチェック
  if (window.innerWidth > 1024) {
    forceCloseHamburger();
  }
});

// -----------------------------------------------
// Swiper初期化
// -----------------------------------------------
function initSwiper() {
  const fvSlider = new Swiper('.js-FV', {
    effect: 'fade',
    speed: 1200,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true, // クリック有効化
    },
    autoplay: {
      // 自動再生
      delay: 5000,
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
  });

  const gallerySlider = new Swiper('.js-gallerySlider', {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    allowTouchMove: false,
    speed: 900,

    // 自動再生
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    //ナビゲーションボタンを表示
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination', //ページネーションの要素のセレクタ
      type: 'bullets', //ページネーションのタイプ
      clickable: true,
    },
  });
}

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  Utils.switchViewport(390);

  //-------------------------------------------
  // イベント
  //-------------------------------------------
  // #から始まるURLクリック
  if (document.querySelector('a[href*="#"]')) {
    document.querySelectorAll('a[href*="#"]').forEach((el) => {
      el.addEventListener('click', (event) => {
        if (Utils.isInPageLink(event)) {
          // ページ内リンクの場合、親イベントを破棄し、スムーズスクロールで移動
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          forceCloseHamburger();
          Utils.movePosition(event.currentTarget);
        }
      });
    });
  }

  //ハンバーガークリック
  if (Utils.isMobile()) {
    if (document.querySelector('.js-hamburger')) {
      document.querySelector('.js-hamburger').addEventListener('click', (event) => toggleHamburger());
    }
  }

  // トップへ戻るアニメーション
  if (document.querySelector('.js-pageTop')) {
    const toTop = document.querySelector('.js-pageTop');
    ScrollTrigger.create({ trigger: 'body', start: 'top+=300 top', end: 'bottom+=100000 bottom', markers: false, toggleClass: { targets: toTop, className: 'visible' } });
  }

  // Swiper初期化
  initSwiper();
});

//一旦ここに追加、体裁は整える。
//-------------------------------------------
// snsメニュー
//-------------------------------------------
// クリックイベントのハンドラを設定
document.querySelectorAll('.js-snsMenu').forEach(function (menu) {
  menu.addEventListener('click', function (event) {
    // クリックした要素内のsnsMenu__items要素を取得
    var snsMenuItems = this.querySelector('.snsMenu__items');

    // クリックした要素以外のすべてのsnsMenu__itemsを非表示にする
    document.querySelectorAll('.js-snsMenu .snsMenu__items').forEach(function (item) {
      if (item !== snsMenuItems) {
        item.classList.remove('is-active');
      }
    });

    // クリックした要素のsnsMenu__itemsにis-activeクラスを付け外し
    snsMenuItems.classList.toggle('is-active');

  });
});

// ホバーイベントのハンドラを設定
document.querySelectorAll('.js-snsMenu').forEach(function (menu) {
  menu.addEventListener('mouseleave', function () {
    // ホバーから外れた時にメニューを非表示にする
    var snsMenuItems = this.querySelector('.snsMenu__items');
    snsMenuItems.classList.remove('is-active');
  });
});

//-----------------------------------------------
// メガメニュー
// -----------------------------------------------
// js-megaMenuContent内のリンクを取得
const megaMenuLinks = document.querySelectorAll('.js-megaMenuContent a');

// 各リンクにイベントリスナーを追加
megaMenuLinks.forEach(function (link) {
  link.addEventListener('click', function () {
    // このリンクが含まれるjs-megaMenuContentを取得
    const megaMenuContent = this.closest('.js-megaMenuContent');
    megaMenuContent.classList.remove('is-active');

    // このリンクが含まれるjs-megaMenuを取得
    const megaMenu = megaMenuContent.closest('.js-megaMenu');
    megaMenu.classList.remove('is-active');
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // メガメニューをクリックしたときの処理
  const megaMenus = document.querySelectorAll('.js-megaMenu');
  megaMenus.forEach(function (menu) {
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
      const menuContent = this.querySelector('.js-megaMenuContent');
      const activeMenus = document.querySelectorAll('.js-megaMenu.is-active');

      // 他のメガメニューの is-active クラスを削除
      activeMenus.forEach(function (activeMenu) {
        if (activeMenu !== menu) {
          activeMenu.classList.remove('is-active');
          const activeMenuContent = activeMenu.querySelector('.js-megaMenuContent');
          activeMenuContent.classList.remove('is-active');
        }
      });

      if (!this.classList.contains('is-active')) {
        this.classList.add('is-active');
        menuContent.classList.add('is-active');
      } else {
        menuContent.classList.remove('is-active');
        this.classList.remove('is-active');
      }
    });
  });

  // メガメニュー内のクローズボタンをクリックしたときの処理
  const megaMenuCloseButtons = document.querySelectorAll('.js-megaMenuClose');
  megaMenuCloseButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      const menuContent = this.closest('.js-megaMenuContent');
      const megaMenu = menuContent.closest('.js-megaMenu');

      menuContent.classList.remove('is-active');
      megaMenu.classList.remove('is-active');
    });
  });

  // ドキュメント全体をクリックしたらメガメニューを閉じる
  document.addEventListener('click', function () {
    const activeMenus = document.querySelectorAll('.js-megaMenu.is-active');
    activeMenus.forEach(function (activeMenu) {
      activeMenu.classList.remove('is-active');
      const menuContent = activeMenu.querySelector('.js-megaMenuContent');
      menuContent.classList.remove('is-active');
    });
  });

  // js-megaMenuContent内のクリックイベントを無効化する
  const megaMenuContents = document.querySelectorAll('.js-megaMenuContent');
  megaMenuContents.forEach(function (content) {
    content.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });
  
});


//-----------------------------------------------
// タブの実装
// -----------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  function toggleClass(target, c) {
    const targetSiblings = getSiblings(target);
    targetSiblings.forEach((el) => {
      el.classList.remove(c);
    });
    target.classList.add(c);
  }

  function getSiblings(e) {
    let siblings = [];
    if (!e.parentNode) {
      return siblings;
    }
    let sibling = e.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }

  function addTabListeners(tabItems, tabContents) {
    tabItems.forEach((element, i) => {
      if (!element.classList.contains('no-content')) {
        element.addEventListener('click', function () {
          if (!element.classList.contains('is-active')) {
            toggleClass(element, 'is-active');
          }
          toggleClass(tabContents[i], 'is-active');
        });
      }
    });
  }

  // タブコントロールのラッパーを取得
  const tabs = document.querySelectorAll('.js-tab');

  if (tabs.length) {
    // 複数タブが存在する場合
    tabs.forEach((tabControl) => {
      const tabItems = tabControl.querySelectorAll('.js-tabItem');
      const tabContents = tabControl.querySelectorAll('.js-tabContent');
      addTabListeners(tabItems, tabContents);
    });
  } else {
    // 単一タブの場合
    const tabItems = document.querySelectorAll('.js-tabItem');
    const tabContents = document.querySelectorAll('.js-tabContent');
    addTabListeners(tabItems, tabContents);
  }
});

// -----------------------------------------------
// アコーディオン内のリンククリック時の処理
// -----------------------------------------------
document.querySelectorAll('.js-drawer-accordion a').forEach(function(link) {
  link.addEventListener('click', function(event) {
    // リンク先に遷移する前にアコーディオンを閉じる
    const accordionContent = link.closest('.js-drawer-accordion');
    const accordionBtn = accordionContent.querySelector('.js-drawer-accordion-btn');
    const accordionInnerContent = accordionContent.children[1]; // アコーディオンのコンテンツ部分を取得

    accordionInnerContent.style.overflow = 'hidden'; // コンテンツ部分のoverflowをhiddenに設定
    accordionInnerContent.style.height = 0; // コンテンツ部分の高さを0に設定

    accordionContent.classList.remove('is-open');
    accordionBtn.classList.remove('is-open');
    
    // リンク先に遷移
    event.preventDefault();
    const href = link.getAttribute('href');
    const target = link.getAttribute('target');
    if (href) {
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    }
  });
});

//-----------------------------------------------
//アコーディオン
// -----------------------------------------------
document.querySelectorAll('.js-drawer-accordion-btn').forEach(function(el){
  el.addEventListener('click', function(){
    const next = el.nextElementSibling;
    const nextH = next.scrollHeight + 'px';
    next.style.overflow = 'hidden';
    next.style.height = next.style.height === nextH ? 0 : nextH;
    const accordionContent = el.closest('.js-drawer-accordion');
    accordionContent.classList.toggle('is-open');
    el.classList.toggle('is-open');
  });
});

//-----------------------------------------------
//フォーム　セレクトボックスのプレイスホルダー
// -----------------------------------------------
if (Utils.isPage('contact')) {
  const select = document.querySelector('.form__select');
  select.addEventListener('change', function () {
    if (select.value !== "") {
      select.classList.remove('form__select');
    } else {
      select.classList.add('form__select');
    }
  });
}

//-----------------------------------------------
//スクロールヒント
// -----------------------------------------------
new ScrollHint(".js-scrollHint", {
  i18n: {
    scrollable: 'スクロールできます'
  },
});